<template lang="pug">
b-modal#updateLinkageRiskWeight(
  ref="updateLinkageRiskWeight"
  :title="$t('ui.combine.change_linkage_risk_weight')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.name')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="type_name"
        required
        type="text"
        v-model.trim.lazy="type_name"
        :disabled="loading"
      )
    b-form-group(:label="$t('ui.risk_weight')").mb-0
      DebounceInput(
        size="sm"
        ref="risk_weight"
        required
        type="text"
        :dirty="$v.risk_weight.$dirty"
        :error="$v.risk_weight.$error"
        v-model.trim.lazy="$v.risk_weight.$model"
        :disabled="loading"
        keyPressRestrict="restrictOnlyNumber"
      )
      ValidateResult(:value="$v.risk_weight" :name="$t('ui.risk_weight')")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      type_name: "",
      risk_weight: null,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    risk_weight: {
      required,
      minValue: minValue(0)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.linkageTypeGlobalUpdateWeightUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          linkage_type: this.item.id,
          risk_weight: this.risk_weight
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.updateLinkageRiskWeight.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "change_linkage_risk_weight", this.feedback.status);
                  this.$refs.updateLinkageRiskWeight.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.type_name = "";
      this.risk_weight = null
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.type_name = this.item.type_name;
      this.risk_weight = this.item.risk_weight;
      this.$refs.risk_weight.$el.focus();
    }
  }
};
</script>
